import { render, staticRenderFns } from "./EventRegister.vue?vue&type=template&id=e26778b0&scoped=true&lang=pug"
import script from "./EventRegister.vue?vue&type=script&lang=ts"
export * from "./EventRegister.vue?vue&type=script&lang=ts"
import style0 from "./EventRegister.vue?vue&type=style&index=0&id=e26778b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26778b0",
  null
  
)

export default component.exports